import IEventType from '@/types/IEventType';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface IUseSectionNotificationsArgs {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export default function useSectionNotifications(args: IUseSectionNotificationsArgs) {
	const { t } = useTranslation();
	const isFetching = useIsFetching() > 0;
	const isMutating = useIsMutating() > 0;

	function handleSmsConfirmationChange(e: ChangeEvent<HTMLInputElement>) {
		const isChecked = e.target.checked;

		return args.onChange({
			notifications: {
				...args.service.notifications,
				confirmation: {
					sms: { enabled: isChecked },
				},
			},
		});
	}

	function handleSmsReminderChange(e: ChangeEvent<HTMLInputElement>) {
		const isChecked = e.target.checked;

		return args.onChange({
			notifications: {
				...args.service.notifications,
				reminders: [
					{
						timeBefore: 'PT24H',
						sms: {
							enabled: isChecked,
						},
					},
				],
			},
		});
	}

	function handleSmsReminderHourChange(e: ChangeEvent<HTMLSelectElement>) {
		const timeBefore = e.target.value;

		return args.onChange({
			notifications: {
				...args.service.notifications,
				reminders: [
					{
						timeBefore: timeBefore,
						sms: {
							enabled: args.service.notifications?.reminders?.at(0)?.sms.enabled || false,
						},
					},
				],
			},
		});
	}

	return {
		t,
		handleSmsReminderChange,
		handleSmsConfirmationChange,
		handleSmsReminderHourChange,
		isLoading: isFetching || isMutating,
	};
}
